// Import the enum directly (not via the @utils barrel) so this pure helper —
// and its unit test — stay free of the heavy toast/UI side of @utils.
import { Scope } from '../../../utils/constants'

export interface MapContactsFilter {
  noGhost?: boolean
  onlyGhost?: boolean
  scope?: Scope
}

/**
 * Derives the `usePaginateContacts` params for the map from the selected
 * scopes. The "Fantôme" filter is a separate bonus set (like the contacts
 * picker):
 * - GHOST selected   -> only ghost profiles, no real-contact scope filter
 * - GHOST not selected -> real contacts only (no ghosts), narrowed to the
 *   first matching real scope (PRIVATE wins over PROFESSIONAL)
 *
 * `false`/`undefined` flags are normalised to `undefined` so they drop out of
 * the query string instead of being sent as `noGhost=false`.
 */
export function buildMapContactsFilter(scope?: Scope[]): MapContactsFilter {
  const isGhostScope = scope?.includes(Scope.GHOST)

  return {
    noGhost: !isGhostScope || undefined,
    onlyGhost: isGhostScope || undefined,
    scope: isGhostScope
      ? undefined
      : scope?.includes(Scope.PRIVATE)
        ? Scope.PRIVATE
        : scope?.includes(Scope.PROFESSIONAL)
          ? Scope.PROFESSIONAL
          : undefined,
  }
}
